import React, { FunctionComponent, MutableRefObject } from 'react'

export const useHistoryScroll: () => {
  scroll: (element: MutableRefObject<HTMLElement>) => void
  CustomScrollMarker: FunctionComponent<{
    topOffset?: number
    innerRef: MutableRefObject<HTMLDivElement>
  }>
} = () => {
  const scroll: (element: MutableRefObject<HTMLElement>) => void = (
    element
  ) => {
    element.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  const CustomScrollMarker: FunctionComponent<{
    topOffset?: number
    innerRef: MutableRefObject<HTMLDivElement>
  }> = ({ topOffset, innerRef }) => {
    topOffset = topOffset ?? 0

    return (
      <div style={{ position: 'relative' }}>
        <div
          ref={innerRef}
          style={{
            position: 'absolute',
            zIndex: -10,
            width: '100%',
            top: -topOffset,
            height: topOffset,
          }}
        />
      </div>
    )
  }

  return { scroll, CustomScrollMarker }
}
